import { render } from "./ExpiredPointDetails.vue?vue&type=template&id=504933e7&ts=true"
import script from "./ExpiredPointDetails.vue?vue&type=script&lang=ts"
export * from "./ExpiredPointDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__